<template lang="html">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 pt-4 sidebar">
        <h5>Navigation</h5>
        <ul class="list-group">
          <li class="list-group-item"><router-link :to="{name:'index'}">Dashboard<i class="fa fa-dashboard float-right"></i></router-link></li>
          <li class="list-group-item"><router-link :to="{name:'search.list'}">Searches <i class="fa fa-search float-right"></i></router-link></li>
          <li class="list-group-item"><router-link :to="{name:'collection.list'}">Collections <i class="fa fa-bookmark float-right"></i></router-link></li>
          <li class="list-group-item"><router-link :to="{name:'download.list'}">Downloads <i class="fa fa-download float-right"></i></router-link></li>
        </ul>

        <hr>

        <h5>Inventory</h5>
        <ul class="list-group">
          <li class="list-group-item"><router-link :to="{name:'document.list'}">Documents<i class="fa fa-file float-right"></i></router-link></li>
          <li class="list-group-item"><router-link :to="{name:'publisher.list'}">Publishers <i class="fa fa-globe float-right"></i></router-link></li>
          <li class="list-group-item"><router-link :to="{name:'author.list'}">Authors <i class="fa fa-user float-right"></i></router-link></li>
        </ul>

        <hr>

        <div class="" v-if="state.user && state.user.is_admin">
          <h5>Administrative</h5>
          <ul class="list-group">
            <li class="list-group-item"><router-link :to="{name:'user.list'}">Manage Users<i class="fa fa-group float-right"></i></router-link></li>
            <li class="list-group-item"><router-link :to="{name:'schedule.list'}">Scrape Schedule <i class="fa fa-clock float-right"></i></router-link></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Store from 'system/store'
import Relay from 'system/relay'
export default {
  data(){
    return {
      state: Store.state
    }
  }
}
</script>

<style lang="css">
</style>
